import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import RequestV2SubmissionDocument from 'processes/requests_v2/request-v2-submission/RequestV2SubmissionDocument';
import RequestV2SubmissionDocumentTabState from 'processes/requests_v2/request-v2-submission/RequestV2SubmissionDocumentTabState';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

export default class RequestV2SubmissionDocumentTabView extends BufferTabView<RequestV2SubmissionDocumentTabState> {
  render(): this {
    const onSubmissionAddProgressAndOutputsTab = (): void => {
      const requestV2SubmissionFileState = this.model.getRequestV2SubmissionFileState();
      requestV2SubmissionFileState.addProgressAndOutputsTab();
    };

    const props = {
      requestV2SubmissionId: this.model.get('id'),
      onSubmissionAddProgressAndOutputsTab,
    };
    renderToDOM(
      <div className="react-tab-container" style={{padding: 0}}>
        <RequestV2SubmissionDocument {...props} />
      </div>,
      this.el
    );
    return this;
  }

  remove(): Backbone.View<RequestV2SubmissionDocumentTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

RequestV2SubmissionDocumentTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
